<script>
import { authComputed, campaignMethods, masterMethods } from '@/state/helpers';
import { checkPermission, getInfoUserLocalStorage } from '@/utils/handlers';
import { keyMaster } from '@/config/constants';
import {
    configs,
    replaceQ,
    replaceA,
    handMapDataDocument2,
    funcConditionLabel,
    initFileDocs,
    onHandleMapCheckSchedule,
    handleTranferShortCodePreview,
    handleTranferShortCodeFaq
} from './main';
import { showMessage } from '@/utils/messages';
import { InputCheckBox } from '@/components/Input';
import { tranferShortCode } from '@/utils/format';
import { campaignStatus } from '@/config/var-common';
import { isRolePartner } from '@/views/pages/require/handlers';

import Layout from '@/views/layouts/main';
import Footer from '@/components/Footer/main.vue';
import appConfig from '@/app.config';
import Multiselect from '@/components/Multiselect/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import HistoryExportDocument from '@/views/pages/documents/TableExportDocument/main.vue';
import PopUpExportSchedule from './popup/schedule/main.vue';
import PopUpFAQ from '@/views/pages/documents/popup/faq/main.vue';
import PopUpCondition from '@/views/pages/documents/popup/condition/main.vue';
import PopUpConditionFMT from '@/views/pages/documents/popup/condition-fmt/main.vue';
import PopUpConditionContactFMT from '@/views/pages/documents/popup/condition-contact-fmt/main.vue';
import PopUpWinningDistribution from '@/views/pages/documents/popup/winning-distribution/main.vue';
import PopUpConditionRule from '@/views/pages/documents/popup/condition-rule/main.vue';
export default {
    page: {
        title: '立ち上げ資料',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        Footer,
        LoadingIcon,
        Multiselect,
        HistoryExportDocument,
        PopUpCondition,
        PopUpConditionFMT,
        PopUpConditionContactFMT,
        PopUpWinningDistribution,
        PopUpFAQ,
        PopUpExportSchedule,
        PopUpConditionRule,
        InputCheckBox
    },
    data() {
        return {
            loading: false,
            activeTab: 0,

            // config
            configSelectCampaign: configs.configSelectCampaign,
            configExportSchedule: configs.configExportSchedule,
            configModalCommonCondition: configs.configModalCommonCondition,
            configModalCommonConditionFMT: configs.configModalCommonConditionFMT,
            configModalConditionContactFMT: configs.configModalConditionContactFMT,
            configModalCommonPreview: configs.configModalCommonPreview,
            configFaq: configs.configFaq,
            configModalCommonConditionOther: configs.configModalCommonConditionOther,
            campaignStatus: campaignStatus,

            listDataMasterCampaign: [],
            listDataMasterClients: [],
            listDataMasterPartners: [],
            isLoading: false,
            indexActive: '',
            clientOther: null,

            listDataMasterCampaignType: [],
            campaign: null,
            listDocuments: initFileDocs(),
            conditions: {},

            campaignType: '',
            templateDetail: {},

            dataDetailForDocument: null,
            detailBeginForDocument: null,
            objExportSchedule: null,
            modalConditionOtherObj: {},
            modalConditionOtherId: '',
            listChildConditionAfterCheckedTab1: [],
            listChildConditionAfterCheckedTab2: [],
            listIDConditionTab2Checked: [],
            listConditionRuleDetail: [],
            listDataType1: [],
            listDataPlatform: [],
            masterTemplateList: [],
            isLoadingConditionOther: false,
            isLoadingTemplate: false,
            progress_status: [],
            dataRuleCurrent: null,
            listCategoriesCampaign: [],
            listCategoriesCampaignId: [],
            listCategoriesMaster: [],
            listAllRule: [],
            intervalId: null,
            isRolePartner: isRolePartner()
        };
    },
    watch: {
        campaign: function (newName) {
            if (newName?.id) {
                this.getListMasterCampaignDetail(newName);
                this.objExportSchedule = null;
            }
        },

        objExportSchedule: function (newName) {
            this.onHandleRecursionSchedule(this.listDocuments, newName);
        }
    },
    mounted() {
        this.configSelectCampaign.error = false;
        this.getAllRule();
        this.getListMasterCampaign();
        this.getListMasterTemplate();
        this.getListMasterCampaignType();
        this.getListMasterScheduleFile();
    },
    computed: {
        ...authComputed,

        isBtnExport() {
            if (!Object.keys(this.conditions).length) return true;
            const hasTrueValue = Object.values(this.conditions).some((value) => value === true);
            return !hasTrueValue;
        }
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('document.export')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    methods: {
        checkPermission,
        ...masterMethods,
        ...campaignMethods,

        conditionLabel(label) {
            return funcConditionLabel(label);
        },

        clearDataOther() {
            if (!this.modalConditionOtherObj || !this.modalConditionOtherObj[this.modalConditionOtherId]) return;
            this.modalConditionOtherObj[this.modalConditionOtherId].categories = [];
        },

        getListMasterCampaignType() {
            this.loading = true;
            this.listMaster(keyMaster['campaign.type']).then((data) => {
                this.listDataMasterCampaignType = data;
                this.loading = false;
            });
        },

        getListMasterTemplate() {
            this.templateList().then((data) => {
                if (data.code == 200) {
                    this.masterTemplateList = data.data;
                    this.handleMapWinningDistributionText(this.masterTemplateList);
                }
                this.loading = false;
            });
        },

        checkPermiss(listRole) {
            return checkPermission(listRole);
        },

        getListMasterCampaign() {
            this.loading = true;
            let query = '';
            if (this.isRolePartner) {
                query = `?has[partner]=${getInfoUserLocalStorage().partner_id ?? ''}`;
            }
            this.getAllDocuments(query).then((data) => {
                if (data.code == 200) {
                    this.listDataMasterCampaign = data.data;
                    if (this.$route.query.id) {
                        let index = this.listDataMasterCampaign.findIndex((x) => {
                            return x.id == this.$route.query.id;
                        });
                        if (index >= 0) {
                            this.campaign = this.listDataMasterCampaign[index];
                        }
                    } else if (this.currentUser.default_campaign) {
                        let index = this.listDataMasterCampaign.findIndex((x) => {
                            return x.id == this.currentUser.default_campaign.id;
                        });
                        if (index >= 0) {
                            this.campaign = this.listDataMasterCampaign[index];
                        }
                    }
                }
                this.loading = false;
            });
        },

        getListMasterCampaignDetail() {
            this.isLoadingConditionOther = true;
            this.getDetailDocuments(this.campaign).then((data) => {
                if (data.code == 200) {
                    const dataRes = data?.data ?? [];
                    this.detailBeginForDocument = dataRes;
                    this.dataRuleTab = [];
                    this.campaignType = dataRes.campaign_type ? dataRes.campaign_type.value : '';
                    if (dataRes.campaign_type) {
                        this.listDataMasterCampaignType.forEach((item) => {
                            if (item.id == dataRes.campaign_type.id) {
                                this.listCategoriesMaster = item.data;
                            }
                        });
                    }

                    dataRes.categories.forEach((item) => {
                        this.listCategoriesCampaign.push(item);
                        this.listCategoriesCampaignId.push(item.category_id);
                    });
                    const seen = new Set();
                    this.listDataMasterClients = dataRes.clients
                        ?.map((itemCl) => {
                            itemCl.client = {
                                ...itemCl.client,
                                client_id: itemCl?.client?.id ?? '',
                                client_name: itemCl?.client?.name ?? ''
                            };
                            return itemCl.client;
                        })
                        .filter((item) => {
                            if (seen.has(item.client_id)) {
                                return false;
                            }
                            seen.add(item.client_id);
                            return true;
                        });

                    this.listDataMasterPartners =
                        dataRes?.partner_shipping_type?.map((item) => {
                            return {
                                id: item.id,
                                name: item.name
                            };
                        }) ?? [];
                }
                this.isLoadingConditionOther = false;
            });
        },

        async fetchWorksByConditionSchedule() {
            try {
                const { data } = await this.getDataByCondition(this.campaign.id);
                if (data) {
                    onHandleMapCheckSchedule(data, this.objExportSchedule, this.listDataType1, this.listDataPlatform);
                }
            } catch (error) {
                console.error(error);
            }
        },

        getListMasterScheduleFile() {
            this.loading = true;
            this.getListScheduleFile()
                .then((dataRespone) => {
                    this.listDataType1 = dataRespone.data.filter((item) => {
                        if (item.type === 1) {
                            item.works.forEach((ws) => {
                                ws.checked = false;
                            });
                            return item;
                        }
                    });
                    this.listDataPlatform = dataRespone.data.filter((item) => {
                        if (item.type === 2) {
                            item.works.forEach((ws) => {
                                ws.checked = false;
                            });
                            return item;
                        }
                    });
                    this.loading = false;
                })
                .catch((error) => {
                    console.log('error', error);
                });
        },

        setData(label, data, dataIdx, childrenKdx, childrenIdx, idx) {
            this.indexActive = childrenKdx;
            switch (label) {
                case this.$t('document.schedule'):
                    this.fetchWorksByConditionSchedule();
                    if (
                        !this.detailBeginForDocument?.campaign_start_date ||
                        !this.detailBeginForDocument?.campaign_end_date ||
                        !this.detailBeginForDocument?.secretariat_end_date
                    ) {
                        showMessage(8080, this.$bvToast, this.$t('document.msgSchedule'));
                        return;
                    }
                    if (this.objExportSchedule && this.objExportSchedule.campaign_start_date) {
                        this.detailBeginForDocument = JSON.parse(JSON.stringify(this.detailBeginForDocument));
                        this.dataDetailForDocument.campaign_start_date = this.objExportSchedule.campaign_start_date;
                        this.dataDetailForDocument.campaign_end_date = this.objExportSchedule.campaign_end_date;
                        this.dataDetailForDocument.secretariat_end_date = this.objExportSchedule.secretariat_end_date;
                        this.configExportSchedule.dataDocument.categories = this.objExportSchedule.categories;
                    } else {
                        this.dataDetailForDocument = this.detailBeginForDocument;
                    }
                    this.configExportSchedule.id = label;
                    this.configExportSchedule.code = data.id;
                    this.configExportSchedule.model = true;
                    this.configExportSchedule.dataCPType = this.listDataMasterCampaignType;
                    this.configExportSchedule.dataDocument = this.dataDetailForDocument;
                    this.configExportSchedule.source = data;
                    this.configExportSchedule.dateShipping = this.objExportSchedule?.date_shipping;
                    this.configExportSchedule.listIDWorks = this.objExportSchedule?.titles ?? [];

                    this.$bvModal.show(label);
                    break;
                case this.$t('document.greetingCard'):
                    if (!this.detailBeginForDocument?.event_prizes || this.detailBeginForDocument.event_prizes.length <= 0) {
                        showMessage(8080, this.$bvToast, this.$t('document.msgGreetingCard'));
                        return;
                    }
                    this.configModalCommonCondition.id = `${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`;
                    this.configModalCommonCondition.model = true;
                    this.configModalCommonCondition.typeDoc = '';
                    this.configModalCommonCondition.defaultClient = true;
                    this.configModalCommonCondition.inforDocGettingCard = data;
                    this.configModalCommonCondition.class = 'h-100';
                    break;
                case this.$t('document.manual'):
                    this.configModalCommonCondition.id = `${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`;
                    this.configModalCommonCondition.model = true;
                    this.configModalCommonCondition.typeDoc = 'document-manual';
                    this.configModalCommonCondition.defaultClient = false;
                    this.configModalCommonCondition.inforDocGettingCard = '';
                    this.configModalCommonCondition.class = 'h-50';
                    break;
                case this.$t('document.mumberOfMessagesFMT'):
                    if (!this.detailBeginForDocument.campaign_start_date || !this.detailBeginForDocument.campaign_end_date) {
                        showMessage(8080, this.$bvToast, this.$t('document.msgFMT'));
                        return;
                    }

                    this.configModalCommonConditionFMT.id = `${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`;
                    this.configModalCommonConditionFMT.model = true;
                    this.configModalCommonConditionFMT.detailBeginForDocument = this.detailBeginForDocument;
                    this.configModalCommonConditionFMT.source = data;
                    break;
                case this.$t('document.contactFMT'):
                    if (!this.detailBeginForDocument.campaign_start_date || !this.detailBeginForDocument.campaign_end_date) {
                        showMessage(8080, this.$bvToast, this.$t('document.msgFMT'));
                        return;
                    }

                    this.configModalConditionContactFMT.id = `${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`;
                    this.configModalConditionContactFMT.model = true;
                    this.configModalConditionContactFMT.detailBeginForDocument = this.detailBeginForDocument;
                    this.configModalConditionContactFMT.source = data;
                    break;
                default:
                    break;
            }
        },
        getAllRule() {
            this.listMasterRule1().then((data) => {
                if (data.code !== 200) return;
                this.listAllRule = data.data;
            });
            return this.listAllRule;
        },
        filterRuleIdsByCategory(ruleIds) {
            const platformsCheckedValues = this.listCategoriesCampaign.map((item) => item.category.value);
            const listCategoryNotChecked = [];
            if (!platformsCheckedValues.includes('ハガキ') && !platformsCheckedValues.includes('店頭')) {
                listCategoryNotChecked.push('ハガキ');
            }
            if (!platformsCheckedValues.includes('WEB') && !platformsCheckedValues.includes('アプリ')) {
                listCategoryNotChecked.push('WEB');
            }
            if (!platformsCheckedValues.includes('X') && !platformsCheckedValues.includes('TikTok')) {
                listCategoryNotChecked.push('X');
            }
            if (!platformsCheckedValues.includes('Instagram') && !platformsCheckedValues.includes('TikTok')) {
                listCategoryNotChecked.push('Instagram');
            }
            if (!platformsCheckedValues.includes('LINE')) {
                listCategoryNotChecked.push('LINE');
            }
            const listAllRuleByCampaginType = this.campaignType === 'クローズ' ? this.listAllRule : this.listAllRule.filter((item) => item.type != 2);
            let ruleIdsAfterRemove = ruleIds
                .filter((id) => listAllRuleByCampaginType.some((rule) => rule.id === id))
                .filter((id) => {
                    return !listAllRuleByCampaginType
                        .filter((item) => item.type === 3)
                        .some((rule) => rule.id === id && listCategoryNotChecked.includes(rule.platforms[0].value));
                });

            return ruleIdsAfterRemove;
        },

        async handleGetRuleSavePayLoad(dataSource, selectSource) {
            this.isLoadingConditionOther = true;
            if (this.dataRuleCurrent) {
                this.isLoadingConditionOther = false;
                selectSource.rule_details = this.dataRuleCurrent.rule_details;
                selectSource.rules = this.dataRuleCurrent.rules;
                selectSource.manualSelected = this.dataRuleCurrent.manualSelected;
                return;
            }
            try {
                const data = await this.getRuleSavePayLoad(dataSource);
                if (data.code == 200) {
                    let dataResponse = data.data;
                    selectSource.rule_details = dataResponse.rule_condition;
                    selectSource.rules = this.filterRuleIdsByCategory(dataResponse.condition_ids);
                    selectSource.manualSelected = dataResponse.manual_selection;
                    return;
                }
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoadingConditionOther = false;
            }
        },

        async setDataOther(data, dataIdx, childrenKdx, childrenIdx, idx) {
            this.indexActive = childrenKdx;
            this.modalConditionOtherId = data.id;
            this.modalConditionOtherObj[this.modalConditionOtherId] = data;
            let dataSource = {
                campaign_id: this.detailBeginForDocument.id,
                source: data.source
            };
            this.configModalCommonConditionOther.id = `${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`;
            this.configModalCommonConditionOther.model = true;
            await this.handleGetRuleSavePayLoad(dataSource, data);
        },
        async setConditionRule(dataForm) {
            let clientId = dataForm?.client?.id ?? dataForm?.client?.client_id ?? null;
            if (!clientId) return;
            this.modalConditionOtherObj[this.modalConditionOtherId].categories = dataForm.platforms;
            this.dataRuleCurrent = dataForm;
            this.clearDataOther();
        },

        async register() {
            this.handleRemoveCampaign();
            let resultMap = handMapDataDocument2(this.listDocuments, this.conditions);
            let objectData = {
                campaign_id: this.campaign?.id ?? null,
                documents: resultMap.documents
            };
            if (!resultMap.check) {
                showMessage(8080, this.$bvToast, '出力条件を設定してください。');
            }
            if (this.loading || !this.campaign?.id || !resultMap.check) return;
            this.loading = true;
            try {
                const data = await this.postDocuments(objectData);
                if (data.code == 200) {
                    showMessage(data.code, this.$bvToast, '登録されました。');
                    this.objExportSchedule = null;
                } else {
                    showMessage(data.code, this.$bvToast, this.$t(data.message));
                }
            } catch (error) {
                showMessage(error.code, this.$bvToast, this.$t(error.message));
            } finally {
                this.loading = false;
                setTimeout(() => {
                    this.activeTab = 1;
                }, 300);
                this.dataRuleCurrent = null;
                this.actionDataContactFMT(null);
                this.actionDataParamaterFMT(null);
            }
        },

        handleTabClick(tabNumber) {
            this.activeTab = tabNumber;
        },
        goToEdit(path) {
            this.$router.push({ path: path });
        },
        goToDetail(path, campaignId) {
            if (!campaignId) return;
            this.$router.push({ path: path, query: { id: campaignId } });
        },

        async showPreview(id) {
            this.templateDetail = {};
            this.configModalCommonPreview.id = id;
            this.configModalCommonPreview.model = true;
            await this.getTemplateDetail(id);
            await this.getListMasterTemplate2();
        },

        async setPreview(data, dataIdx, childrenKdx, childrenIdx, idx) {
            if (!this.campaign?.id) return;
            this.configFaq.listData = {};
            this.configFaq.listTitle = {};
            this.configFaq.listFAQ = {};
            this.configFaq.id = `${childrenKdx}-${dataIdx}-${idx}-${childrenIdx}`;
            this.configFaq.model = true;
            this.configFaq.isLoadingPreviewFAQ = true;
            this.campaign = {
                ...this.campaign,
                campaign_id: this.campaign?.id ?? null,
                source: 'faq'
            };
            try {
                const checkSyncStatus = async () => {
                    // eslint-disable-next-line no-async-promise-executor
                    return new Promise(async (resolve) => {
                        try {
                            const dataSyncFaq = await this.syncStatusFaqForCampaign({
                                campaign_id: this.campaign?.id ?? null
                            });
                            const isSynced = dataSyncFaq?.code === 200 && dataSyncFaq?.data?.is_sync_campaign_faq === 0;
                            resolve(isSynced);
                        } catch (error) {
                            resolve(false);
                        }
                    });
                };
                let isSynced = false;
                let attempts = 0;
                const maxAttempts = 30;
                const processAfterSync = async () => {
                    const dataPost = await this.postDocumentFAQPreview(this.campaign);
                    if (dataPost?.code !== 200) return;
                    const context_data = dataPost?.data?.context_data || {};
                    this.configFaq.contextData = context_data;
                    const documentFaqData = await this.getDocumentFAQ(this.campaign);
                    if (documentFaqData?.code !== 200 || !Array.isArray(documentFaqData.data)) return;
                    documentFaqData.data.forEach((item) => {
                        const sheetName = item?.sheet_name;
                        if (!sheetName) return;
                        if (!this.configFaq.listData[sheetName]) {
                            this.configFaq.listData[sheetName] = {};
                        }
                        if (Array.isArray(item.answers)) {
                            item.answers.forEach((ans) => {
                                const categoryId = ans?.category_id;
                                if (!categoryId) return;
                                if (!this.configFaq.listTitle[sheetName]) {
                                    this.configFaq.listTitle[sheetName] = {};
                                }
                                if (!this.configFaq.listTitle[sheetName][categoryId]) {
                                    this.renderNameTitle(sheetName, categoryId);
                                }
                            });
                        }
                        const faqId = item?.id;
                        const questionId = item?.question_id;
                        if (!faqId || !questionId) return;
                        if (!this.configFaq.listData[sheetName][faqId]) {
                            this.configFaq.listData[sheetName][faqId] = {
                                ...item,
                                question: replaceQ(item.question || '', context_data),
                                answers: [],
                                message_to: replaceQ(item.message_to || '', context_data),
                                secretariat_notices: replaceQ(item.secretariat_notices || '', context_data)
                            };
                        }
                        if (Array.isArray(item.answers)) {
                            this.configFaq.listData[sheetName][faqId].answers.push(...replaceA(item.answers, context_data));
                        }
                    });
                    const apiDataPost = await this.postDocumentFAQ(this.campaign);
                    if (apiDataPost?.code !== 200) return;
                    const result = handleTranferShortCodeFaq(apiDataPost.data, context_data);
                    this.configFaq.listFAQ = JSON.parse(JSON.stringify(result));
                    this.configFaq.isLoadingPreviewFAQ = false;
                };
                this.intervalId = setInterval(async () => {
                    if (isSynced) {
                        clearInterval(this.intervalId);
                        return;
                    }
                    attempts++;
                    const syncStatus = await checkSyncStatus();
                    if (syncStatus) {
                        isSynced = true;
                        clearInterval(this.intervalId);
                        await processAfterSync();
                    } else if (attempts >= maxAttempts) {
                        clearInterval(this.intervalId);
                    }
                }, 5000);
                const initialCheck = await checkSyncStatus();
                if (initialCheck) {
                    isSynced = true;
                    await processAfterSync();
                }
            } catch (error) {
                this.configFaq.isLoadingPreviewFAQ = false;
            }
        },

        renderNameTitle(sheetName, category_id) {
            this.listDataMasterCampaignType.forEach((item) => {
                item.data.forEach((aTem) => {
                    if (category_id == aTem.id) {
                        this.configFaq.listTitle[sheetName][category_id] = aTem.value;
                    }
                });
            });
        },
        async getTemplateDetail(id) {
            let template = {
                id: id ? id.replace('c', '') : ''
            };
            this.isLoadingTemplate = true;
            try {
                const data = await this.templateGetDetail(template);
                if (data.code !== 200 || !data?.data) return;
                this.templateDetail = data.data;
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoadingTemplate = false;
            }
        },

        async getListMasterTemplate2() {
            let campaign = {
                campaign_id: this.campaign?.id ?? null
            };
            this.isLoadingTemplate = true;
            try {
                const data = await this.documentPreview(campaign);
                if (data.code !== 200) return;
                const prizeReplacements = handleTranferShortCodePreview(data);
                let data1 = JSON.parse(JSON.stringify(this.templateDetail.content));
                data1 = tranferShortCode(data1, prizeReplacements);
                this.templateDetail.content = JSON.parse(JSON.stringify(data1));
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoadingTemplate = false;
            }
        },

        isActivePopUpCondition(idActive, type) {
            switch (type) {
                case 'condition':
                    return idActive === this.configModalCommonCondition.id;
                case 'condition-fmt':
                    return idActive === this.configModalCommonConditionFMT.id;
                case 'condition-contact-fmt':
                    return idActive === this.configModalConditionContactFMT.id;
                case 'condition-other':
                    return idActive === this.configModalCommonConditionOther.id;
                case 'faq-preview':
                    return idActive === this.configFaq.id;
            }
        },

        handleRemoveCampaign(type = null) {
            if (!this.configSelectCampaign?.valueSync?.id) {
                this.configSelectCampaign.error = true;
            }
            if (type == 'click') {
                this.conditions = {};
                this.listDocuments = initFileDocs();
                this.handleMapWinningDistributionText(this.masterTemplateList);
            }
        },

        handleSelectCampaign() {
            this.configSelectCampaign.error = false;
            this.conditions = {};
            this.listDocuments = initFileDocs();
            this.handleMapWinningDistributionText(this.masterTemplateList);
        },

        onHandleOpenListCampaign() {
            let query = '';
            if (this.progress_status?.length > 0) {
                query = `?filters[progress_status]=${this.progress_status}`;
            }
            if (this.isRolePartner) {
                query = !query
                    ? `?has[partner]=${getInfoUserLocalStorage().partner_id ?? ''}`
                    : `${query}&has[partner]=${getInfoUserLocalStorage().partner_id ?? ''}`;
            }
            this.listDataMasterCampaign = [];
            if (this.configSelectCampaign.loading) return;
            this.configSelectCampaign.loading = true;
            this.getAllDocuments(query).then((data) => {
                if (data.code == 200) {
                    this.listDataMasterCampaign = data.data;
                    this.configSelectCampaign.loading = false;
                }
            });
        },

        handleMapWinningDistributionText(paramData) {
            this.onHandleRecursionKeyDoc(this.listDocuments, paramData);
        },

        onHandleRecursionKeyDoc(listDoc, parData) {
            listDoc.forEach((org) => {
                if (org.children) {
                    this.onHandleRecursionKeyDoc(org.children, parData);
                } else if (org.data) {
                    parData.forEach((jtem) => {
                        if (jtem?.is_create == 1 && org.parent_label == this.$t('document.customizeItYourself')) {
                            org.data.push({
                                id: `${jtem.id}c`,
                                name: jtem.name,
                                source: jtem.id
                            });
                        }
                        if (jtem?.is_create == 0 && org.parent_label == this.$t('document.winningDistributionText')) {
                            if (jtem.type === org.type) {
                                org.data.push({
                                    id: `${jtem.id}c`,
                                    name: jtem.name,
                                    source: jtem.id
                                });
                            }
                        }
                    });
                }
            });
        },

        onHandleRecursionSchedule(listDoc, newName) {
            listDoc.forEach((org) => {
                if (org.children) {
                    this.onHandleRecursionSchedule(org.children, newName);
                } else if (org?.data) {
                    org?.data?.forEach((dataChild) => {
                        if (org.parent_label === this.$t('document.schedule')) {
                            if (dataChild.id === newName?.parentID) {
                                dataChild.conditions = newName;
                            }
                        }
                    });
                }
            });
        },

        getGroupRowspan(originDoc) {
            return originDoc.children.reduce((sum, itemChildren) => {
                return (
                    sum +
                    itemChildren.children.reduce((subSum, ktemChildren) => {
                        return subSum + ktemChildren.data.length;
                    }, 0)
                );
            }, 0);
        },

        getItemChildrenRowspan(itemChild) {
            return itemChild.children.reduce((sum, ktemChild) => {
                return sum + ktemChild.data.length;
            }, 0);
        },

        getKtemChildrenRowspan(ktemChild) {
            return ktemChild.data.length;
        },

        onHandleCheckedFile(kchildrenFile, childrenFile, objFile, dataIdx, childrenKdx, childrenIdx, idx) {
            const optionsClientType = this.listDataMasterClients
                .filter((item) => item.type_id == 1)
                .filter((item, index, self) => index === self.findIndex((i) => i.name === item.name));
            const optionsPartner = this.listDataMasterPartners.filter((item, index, self) => index === self.findIndex((i) => i.name === item.name));
            let { client_generate_file, categories } = this.detailBeginForDocument;

            switch (childrenFile.label) {
                case this.$t('document.manual'):
                    objFile.client = {
                        client_id: client_generate_file?.id ?? null,
                        client_name: client_generate_file?.name ?? ''
                    };
                    objFile.client_type = optionsClientType[0] ? optionsClientType[0] : null;
                    objFile.partner = optionsPartner[0] ? optionsPartner[0] : null;
                    break;
                case this.$t('document.greetingCard'):
                    objFile.client = {
                        client_id: client_generate_file?.id ?? null,
                        client_name: client_generate_file?.name ?? ''
                    };
                    if (!this.detailBeginForDocument?.event_prizes || this.detailBeginForDocument.event_prizes.length <= 0) {
                        showMessage(8080, this.$bvToast, this.$t('document.msgGreetingCard'));
                        return;
                    }
                    break;
            }

            if (
                this.conditions[objFile.id] &&
                this.conditionLabel(childrenFile.label) &&
                !objFile.client &&
                !objFile?.conditions?.campaign_start_date
            ) {
                if (childrenFile.label == this.$t('document.rule')) {
                    objFile.client = client_generate_file
                        ? {
                              client_id: client_generate_file?.id ?? this.listDataMasterClients[0]?.id,
                              client_name: client_generate_file?.name ?? this.listDataMasterClients[0]?.name
                          }
                        : null;
                    objFile.platforms = categories.map((item) => item.category_id);
                    this.setDataOther(objFile, dataIdx, childrenKdx, childrenIdx, idx);
                } else if (childrenFile.label == this.$t('document.partnerRequestSheet')) {
                    this.$router.push({
                        path: `${objFile.path}?id=${this.campaign?.id}`
                    });
                } else if (
                    childrenFile.label !== this.$t('document.winningDistributionText') &&
                    childrenFile.label !== this.$t('document.customizeItYourself')
                ) {
                    this.setData(childrenFile.label, objFile, dataIdx, childrenKdx, childrenIdx, idx);
                } else {
                    this.showPreview(objFile.id);
                }

                // if (objFile.preview) {
                //     this.setPreview(objFile, childrenIdx, dataIdx, idx);
                // }
            }
        },

        handleCloseModalFaq() {
            clearInterval(this.intervalId);
        }
    }
};
</script>

<template>
    <Layout>
        <div v-if="!loading">
            <div class="col-lg-12">
                <div class="card mb-0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 custom--tabss">
                                <b-tabs justified nav-class="nav-tabs-custom cus-document" content-class="p-3 text-muted" v-model="activeTab">
                                    <b-tab @click="handleTabClick(0)" class="border-0">
                                        <template v-slot:title>
                                            <span class="">一覧</span>
                                        </template>

                                        <div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">進捗ステータス</label>
                                                <div class="col-sm-9">
                                                    <div class="d-flex flex-wrap">
                                                        <div v-for="item in campaignStatus" :key="item.id + 's'">
                                                            <InputCheckBox
                                                                class="mr-3 mb-2"
                                                                :model.sync="progress_status"
                                                                :id="`check-document--progress_status_${item.id}`"
                                                                :value="item.id"
                                                                :label="item.text"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-sm-3">キャンペーン名 <span class="text-danger">*</span></label>
                                                <div class="col-sm-8">
                                                    <div class="d-flex">
                                                        <div class="col-sm-8 p-0">
                                                            <Multiselect
                                                                :id="`select-campaign`"
                                                                :value.sync="campaign"
                                                                :options="listDataMasterCampaign"
                                                                :config.sync="configSelectCampaign"
                                                                @open="onHandleOpenListCampaign"
                                                                @select="handleSelectCampaign"
                                                                @remove="handleRemoveCampaign('click')"
                                                            />
                                                            <div v-if="configSelectCampaign.error" class="d-block invalid-feedback">
                                                                {{ configSelectCampaign.errorMsg }}
                                                            </div>
                                                        </div>
                                                        <div class="d-flex ml-3 flex-wrap" style="gap: 1rem">
                                                            <button
                                                                v-if="checkPermission('campaign.view')"
                                                                @click="goToDetail('/campaign/form/view', campaign?.id)"
                                                                class="btn btn-common btn-info"
                                                                style="margin-bottom: 1px; min-width: 76px"
                                                            >
                                                                <i class="ri-file-list-2-line"></i>{{ $t('btn.detail') }}
                                                            </button>
                                                            <button
                                                                v-if="checkPermission('campaign.view')"
                                                                @click="goToEdit('/campaign/list')"
                                                                class="btn btn-primary"
                                                                style="margin-bottom: 1px; min-width: 80px"
                                                            >
                                                                キャンペーン一覧ページ
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="table-responsive">
                                                <table class="table mb-0 table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>大項目</th>
                                                            <th>中項目</th>
                                                            <th>小項目</th>
                                                            <th>ファイル名</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(originDoc, idx) in listDocuments">
                                                            <template v-for="(itemChildren, childrenIdx) in originDoc.children">
                                                                <template v-for="(ktemChildren, childrenKdx) in itemChildren.children">
                                                                    <tr
                                                                        v-for="(otemData, dataIdx) in ktemChildren.data"
                                                                        :key="`keyDocument-${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`"
                                                                    >
                                                                        <td
                                                                            v-if="dataIdx === 0 && childrenKdx === 0 && childrenIdx === 0"
                                                                            :rowspan="getGroupRowspan(originDoc)"
                                                                        >
                                                                            {{ originDoc.label }}
                                                                        </td>
                                                                        <td
                                                                            v-if="childrenKdx === 0 && dataIdx === 0"
                                                                            :rowspan="getItemChildrenRowspan(itemChildren)"
                                                                        >
                                                                            {{ itemChildren.label }}
                                                                        </td>
                                                                        <td v-if="dataIdx === 0" :rowspan="getKtemChildrenRowspan(ktemChildren)">
                                                                            {{ ktemChildren.label }}
                                                                        </td>
                                                                        <td>
                                                                            <div style="width: 100%">
                                                                                <div
                                                                                    v-if="
                                                                                        !['エスカレーション', 'PDCAアポ資料'].includes(
                                                                                            itemChildren.label
                                                                                        )
                                                                                    "
                                                                                    class="d-flex align-items-center"
                                                                                    style="gap: 0.4rem"
                                                                                >
                                                                                    <InputCheckBox
                                                                                        v-if="
                                                                                            ![`${$t('document.partnerRequestSheet')}`].includes(
                                                                                                itemChildren.label
                                                                                            )
                                                                                        "
                                                                                        :model.sync="conditions[otemData.id]"
                                                                                        :id="`checks${otemData.id}`"
                                                                                        :value="otemData.source"
                                                                                        :label="``"
                                                                                        @change="
                                                                                            onHandleCheckedFile(
                                                                                                ktemChildren,
                                                                                                itemChildren,
                                                                                                otemData,
                                                                                                dataIdx,
                                                                                                childrenKdx,
                                                                                                childrenIdx,
                                                                                                idx
                                                                                            )
                                                                                        "
                                                                                    />

                                                                                    <div>
                                                                                        <button
                                                                                            :disabled="!campaign?.id"
                                                                                            v-if="otemData.preview"
                                                                                            @click="
                                                                                                setPreview(
                                                                                                    otemData,
                                                                                                    dataIdx,
                                                                                                    childrenKdx,
                                                                                                    childrenIdx,
                                                                                                    idx
                                                                                                )
                                                                                            "
                                                                                            class="btn btn-sm btn-outline-primary"
                                                                                            style="min-width: 90px"
                                                                                        >
                                                                                            プレビュー
                                                                                        </button>

                                                                                        <template v-else>
                                                                                            <button
                                                                                                v-if="itemChildren.label == $t('document.rule')"
                                                                                                :disabled="!conditions[otemData.id] || !campaign?.id"
                                                                                                @click="
                                                                                                    setDataOther(
                                                                                                        otemData,
                                                                                                        dataIdx,
                                                                                                        childrenKdx,
                                                                                                        childrenIdx,
                                                                                                        idx
                                                                                                    )
                                                                                                "
                                                                                                class="btn btn-sm btn-outline-info"
                                                                                                style="min-width: 70px"
                                                                                            >
                                                                                                設定
                                                                                            </button>
                                                                                            <button
                                                                                                v-else-if="
                                                                                                    itemChildren.label ==
                                                                                                    $t('document.partnerRequestSheet')
                                                                                                "
                                                                                                :disabled="!campaign?.id"
                                                                                                @click="
                                                                                                    () => {
                                                                                                        $router.push({
                                                                                                            path: `/require?id=${campaign?.id}`
                                                                                                        });
                                                                                                    }
                                                                                                "
                                                                                                class="btn btn-sm btn-outline-info"
                                                                                                style="min-width: 70px"
                                                                                            >
                                                                                                {{ $t('btn.detail') }}
                                                                                            </button>
                                                                                            <button
                                                                                                v-else-if="
                                                                                                    itemChildren.label !==
                                                                                                        $t('document.winningDistributionText') &&
                                                                                                    itemChildren.label !==
                                                                                                        $t('document.customizeItYourself')
                                                                                                "
                                                                                                :disabled="!conditions[otemData.id] || !campaign?.id"
                                                                                                @click="
                                                                                                    setData(
                                                                                                        itemChildren.label,
                                                                                                        otemData,
                                                                                                        dataIdx,
                                                                                                        childrenKdx,
                                                                                                        childrenIdx,
                                                                                                        idx
                                                                                                    )
                                                                                                "
                                                                                                class="btn btn-sm btn-outline-info"
                                                                                                style="min-width: 70px"
                                                                                            >
                                                                                                設定
                                                                                            </button>
                                                                                            <button
                                                                                                v-else
                                                                                                :disabled="!campaign?.id"
                                                                                                @click="showPreview(otemData.id)"
                                                                                                class="btn btn-sm btn-outline-primary"
                                                                                                style="min-width: 90px"
                                                                                            >
                                                                                                プレビュー
                                                                                            </button>

                                                                                            <PopUpConditionFMT
                                                                                                v-if="
                                                                                                    isActivePopUpCondition(
                                                                                                        `${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`,
                                                                                                        'condition-fmt'
                                                                                                    )
                                                                                                "
                                                                                                :id="`${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`"
                                                                                                :dataCondition.sync="otemData.conditions"
                                                                                                :config="configModalCommonConditionFMT"
                                                                                                @refresh="getListMasterCampaignDetail"
                                                                                            />
                                                                                            <PopUpConditionContactFMT
                                                                                                v-if="
                                                                                                    isActivePopUpCondition(
                                                                                                        `${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`,
                                                                                                        'condition-contact-fmt'
                                                                                                    )
                                                                                                "
                                                                                                :id="`${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`"
                                                                                                :dataCondition.sync="otemData.conditions"
                                                                                                :config="configModalConditionContactFMT"
                                                                                                @refresh="getListMasterCampaignDetail"
                                                                                            />

                                                                                            <PopUpCondition
                                                                                                v-if="
                                                                                                    isActivePopUpCondition(
                                                                                                        `${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`,
                                                                                                        'condition'
                                                                                                    )
                                                                                                "
                                                                                                :id="`${childrenKdx}${dataIdx}`"
                                                                                                :clientCondition.sync="otemData.client"
                                                                                                :clientConditionType.sync="otemData.client_type"
                                                                                                :partnerCondition.sync="otemData.partner"
                                                                                                :dataMasterClients="listDataMasterClients"
                                                                                                :dataMasterPartners="listDataMasterPartners"
                                                                                                :dataForDocument="detailBeginForDocument"
                                                                                                :config="configModalCommonCondition"
                                                                                            />
                                                                                            <PopUpConditionRule
                                                                                                v-if="
                                                                                                    isActivePopUpCondition(
                                                                                                        `${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`,
                                                                                                        'condition-other'
                                                                                                    )
                                                                                                "
                                                                                                :formRule="otemData"
                                                                                                :loading="isLoadingConditionOther"
                                                                                                :config="configModalCommonConditionOther"
                                                                                                :masterClients="listDataMasterClients"
                                                                                                :campaignType="campaignType"
                                                                                                :listCategoriesCampaign="listCategoriesCampaignId"
                                                                                                :listCategoriesMaster="listCategoriesMaster"
                                                                                                :listAllRule="listAllRule"
                                                                                                @saveConditionRule="setConditionRule"
                                                                                                @close="clearDataOther"
                                                                                            />
                                                                                        </template>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p class="mb-0 font-weight-bold">{{ otemData.name }}</p>
                                                                                        <div
                                                                                            v-if="
                                                                                                conditions[otemData.id] &&
                                                                                                conditionLabel(itemChildren.label)
                                                                                            "
                                                                                            class="error"
                                                                                        >
                                                                                            <span
                                                                                                v-if="
                                                                                                    !otemData.client &&
                                                                                                    !otemData?.conditions?.campaign_start_date
                                                                                                "
                                                                                            >
                                                                                                出力条件を設定してください。
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div v-else>
                                                                                    <InputCheckBox
                                                                                        :model.sync="conditions[otemData.id]"
                                                                                        :id="`checks${otemData.id}`"
                                                                                        :value="otemData.source"
                                                                                        :label="otemData.name"
                                                                                    />
                                                                                </div>
                                                                                <PopUpFAQ
                                                                                    v-if="
                                                                                        isActivePopUpCondition(
                                                                                            `${dataIdx}-${childrenKdx}-${childrenIdx}-${idx}`,
                                                                                            'faq-preview'
                                                                                        )
                                                                                    "
                                                                                    :config.sync="configFaq"
                                                                                    @closeModalFaq="handleCloseModalFaq"
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </b-tab>
                                    <b-tab @click="handleTabClick(1)" class="border-0">
                                        <template v-slot:title>
                                            <span class="">出力結果</span>
                                        </template>

                                        <div>
                                            <HistoryExportDocument :activeTab="activeTab" />
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer v-if="[0].includes(activeTab)">
                <div class="d-flex justify-content-center">
                    <div class="text-center box__button--custom">
                        <button
                            v-if="activeTab !== 1 && checkPermission('document.export')"
                            type="button"
                            @click="register()"
                            class="btn btn-common btn-primary"
                            style="padding-inline: 1.5rem"
                            :class="`${isBtnExport ? 'disabled_cursor' : ''} `"
                            :disabled="isBtnExport"
                        >
                            出力
                        </button>
                    </div>
                </div>
            </Footer>

            <PopUpExportSchedule
                :config="configExportSchedule"
                :exportSchedule.sync="objExportSchedule"
                :masterDataType1="listDataType1"
                :masterDataPlatform="listDataPlatform"
            />

            <PopUpWinningDistribution :dataTemplateDetail="templateDetail" :loading="isLoadingTemplate" :config="configModalCommonPreview" />
        </div>

        <div class="d-flex justify-content-center" v-else>
            <LoadingIcon />
        </div>
    </Layout>
</template>

<style lang="scss" scoped>
.table-bordered td,
.table-bordered th {
    border: 1px solid #c2c2c2;
}
td,
th {
    vertical-align: middle;
}
.item2 {
    padding-top: 5px;
}
.item2:last-child {
    border: 0 !important;
}
.item2:hover {
    background: rgba(239, 239, 239, 0.28);
}
</style>
<style lang="scss"></style>
